import type React from "react";
import styles from "./AmountDot.module.css";

export type AmountDotProps = {
	children: React.ReactNode;
	amount: number;
};

export const AmountDot = ({ children, amount }: AmountDotProps) => {
	return (
		<div className={styles.root}>
			<span className={styles.amount}>{amount}</span>
			{children}
		</div>
	);
};
